import React from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const CalendarHeader = ({ currentMonth, setCurrentMonth }) => {
    const handlePrevMonth = (event) => {
        event.preventDefault();
        setCurrentMonth(
            new Date(currentMonth.setMonth(currentMonth.getMonth() - 1))
        );
    };

    const handleNextMonth = (event) => {
        event.preventDefault();
        setCurrentMonth(
            new Date(currentMonth.setMonth(currentMonth.getMonth() + 1))
        );
    };

    return (
        <div className="calendar-header">
            <button onClick={handlePrevMonth}>
                <IoIosArrowBack />
            </button>
            <span>
                {currentMonth.toLocaleDateString("default", {
                    month: "long",
                    year: "numeric",
                })}
            </span>
            <button onClick={handleNextMonth}>
                <IoIosArrowForward />
            </button>
        </div>
    );
};

export default CalendarHeader;
